import { string } from "prop-types";
import styled from "styled-components";
export const Button = styled.button`
  background: gray;
  color: white;
  border: none;
  font-size: 1.5em;
  padding: 10px 20px;
  cursor: pointer;
  box-shadow: #333 3px 3px;
  border-radius: 3px;
  font-family: "Lobster", cursive;
  position: absolute;
  top: 60vh;
  &:hover {
    background: black;
  }
  @media (max-width: 768px) {
    font-size: 1em;
    top: 70vh;
  }
`;
